// Centralized config - easy for Mason to edit later
export const SITE = {
  brand: "Uberti Creative",
  owner: "Mason Uberti",
  email: "UbertiCreative@gmail.com",
  instagram: "UbertiCreative",
  instagramUrl: "https://instagram.com/UbertiCreative",
  location: "Vaughan / GTA",
  discoveryFormUrl:
    "https://docs.google.com/forms/d/e/1FAIpQLSemcJkuWVD3SS2igIGAa93IxcUjkCYoQSqzY57GNyZWics61w/viewform",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/eyhr4imn_0A1A21D5-90FF-4001-B98F-FCB8E70CBFAE.jpeg",
};

// Brand photography — uploaded shoot
export const BRAND_PHOTOS = {
  engravedSign:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/t1s8moz6_5A9BB453-3971-4BCD-A988-21D018BAEF83.jpeg",
  workspace:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/1cilk2v8_630E38CE-413E-4DCB-ACAB-D52951FB972B.png",
  brandMockup:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/l0fh8gjm_8F86C2E1-4505-49E8-BFC2-AF86D35D72BF.png",
  notebook:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/cxv19bsx_94A93C11-5F59-477A-A553-8A7E50D6950F.png",
};

// Founder photography — formal Uberti Creative shoot
export const FOUNDER_PHOTOS = {
  // Wide seated office shot (hero)
  seatedDesk:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/vg4zo4mx_749D5AE4-95D6-46AD-9175-03049C697B7F.png",
  // Close-up chest-up headshot (about / meet the founder)
  headshot:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/b93i6rf9_22B44DCE-4C8E-4CD6-9E43-4751876B5DFC.png",
  // Updated polished headshot — Mason in black blazer with UC wall logo
  headshot2:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/zg66a1bk_C07973C8-8577-43A3-87E1-6D05C93A75AC.png",
  // Working at laptop (process / strategy)
  atLaptop:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/rzs5e1l8_B4456F22-BFD0-476B-9F8F-504478B3B7BE.png",
  // Standing portrait, hand in pocket (leadership)
  standing:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/ks5nfwdh_FFC9A689-45E8-4BFC-98EA-C8B6A7B27201.png",
  // Tight head-and-shoulders (contact)
  tightPortrait:
    "https://customer-assets.emergentagent.com/job_better-online-1/artifacts/uvke62li_E67F7957-645A-49DD-AF35-8611E8B5F229.png",
};

// Real client work — easy to add more or swap images later
export const CLIENTS = {
  cercanTile: {
    name: "Cercan Tile",
    handle: "cercantile",
    url: "https://instagram.com/cercantile",
  },
  lugHollywood: {
    name: "Lug Hollywood",
    handle: "Lughollywood",
    url: "https://instagram.com/Lughollywood",
  },
};
